import { ref, onMounted } from '@vue/composition-api';

import {
  PACKAGE_NAME_TO_SUBSCRIBER_PACKAGE_ID,
  SOBJECTS_THAT_REQUIRE_CPQ_DEPLOYER_PACKAGE,
} from '@/constants';

import { SObject } from '@/types';
import useDI from './useDI';

let loaded = false;
const loading = ref(false);

const isPackageInstalledInSource = ref(false);
const isPackageInstalledInTarget = ref(false);

export default function useDeployerPackageInstalled() {
  const subscriberPackageId =
    PACKAGE_NAME_TO_SUBSCRIBER_PACKAGE_ID.CPQ_DEPLOYER;
  const { container, Tokens } = useDI();
  const salesforceService = container.get(Tokens.SalesforceService);

  async function load() {
    if (loaded || loading.value) {
      return;
    }
    try {
      loading.value = true;
      const { isInstalledInSource, isInstalledInTarget } =
        await salesforceService.isPackageInstalled(subscriberPackageId);

      isPackageInstalledInSource.value = isInstalledInSource;
      isPackageInstalledInTarget.value = isInstalledInTarget;
      loaded = true;
    } finally {
      loading.value = false;
    }
  }

  onMounted(load);

  async function refresh() {
    loaded = false;
    return load();
  }

  const isDeployable = (sobject: SObject) => {
    if (!SOBJECTS_THAT_REQUIRE_CPQ_DEPLOYER_PACKAGE[sobject]) {
      return true;
    }

    return isPackageInstalledInSource.value && isPackageInstalledInTarget.value;
  };

  return {
    loading,
    isPackageInstalledInSource,
    isPackageInstalledInTarget,
    refresh,
    isDeployable,
  };
}
